import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';
import { Check as CheckIcon, Error as ErrorIcon, Warning as WarningIcon, Info as InfoIcon } from '@mui/icons-material';
import { useSnackbarStore } from '../store/useSnackbarStore';

const SnackbarAlert = () => {
  const { open, message, severity, closeSnackbar } = useSnackbarStore();
  const [messageQueue, setMessageQueue] = useState<{ message: string; severity: AlertColor }[]>([]); // 큐를 올바른 타입으로 정의
  const [currentMessage, setCurrentMessage] = useState<{ message: string; severity: AlertColor } | null>(null);
  const [isDisplaying, setIsDisplaying] = useState(false);

  // 아이콘 선택 함수
  const getIconForSeverity = (severity: string): React.ReactNode => {
    switch (severity) {
      case 'success':
        return <CheckIcon fontSize="inherit" />;
      case 'error':
        return <ErrorIcon fontSize="inherit" />;
      case 'warning':
        return <WarningIcon fontSize="inherit" />;
      case 'info':
        return <InfoIcon fontSize="inherit" />;
      default:
        return null;
    }
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return; // 클릭으로 닫히는 이벤트 방지
    setIsDisplaying(false);
    closeSnackbar(); // 상태 초기화
  };

  // 메시지 큐에 추가
  useEffect(() => {
    if (message) {
      setMessageQueue((prevQueue) => [...prevQueue, { message, severity }]);
    }
  }, [message, severity]);

  // 메시지 표시 및 큐 처리
  useEffect(() => {
    if (!isDisplaying && messageQueue.length > 0) {
      const nextMessage = messageQueue[0];
      setCurrentMessage(nextMessage);
      setMessageQueue((prevQueue) => prevQueue.slice(1)); // 큐에서 제거
      setIsDisplaying(true);
    }
  }, [messageQueue, isDisplaying]);

  useEffect(() => {
    if (isDisplaying) {
      const timer = setTimeout(() => {
        setIsDisplaying(false);
      }, 2500); // 메시지 표시 시간
      return () => clearTimeout(timer);
    }
  }, [isDisplaying]);

  // 페이지 이동하거나 닫힘버튼 눌렀을때, 초기화함
  useEffect(() => {
    setMessageQueue([]);
    setCurrentMessage(null);
    setIsDisplaying(false);
    closeSnackbar(); // 상태초기화
  }, [location, closeSnackbar]);

  return (
    <>
      {currentMessage && isDisplaying && (
        <Snackbar open={isDisplaying} autoHideDuration={2500} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            onClose={handleClose}
            severity={currentMessage.severity}
            icon={getIconForSeverity(currentMessage.severity)}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            {currentMessage.message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default SnackbarAlert;
